import React from "react";
import AdminLayout from "../../layouts/AdminLayout";
import { StatCard, PageHeader } from "./components";
import { RevenueChart } from "./components/charts";

function AdminPanel() {
    // Örnek veriler
    const yachtData = [
        {
            id: "YR0781",
            name: "Azimut 55",
            status: "Tamamlandı",
            captain: "Mehmet Yılmaz",
            earnings: "€3,544",
            startDate: "5-10-2023",
            endDate: "7-10-2023",
        },
        {
            id: "YR0467",
            name: "Sunseeker 75",
            status: "Beklemede",
            captain: "Ali Kaya",
            earnings: "€0.00",
            startDate: "6-10-2023",
            endDate: "9-10-2023",
        },
        {
            id: "YR0303",
            name: "Princess 62",
            status: "Seyirde",
            captain: "Ayşe Demir",
            earnings: "€2,350",
            startDate: "3-10-2023",
            endDate: "6-10-2023",
        },
    ];

    return (
        <AdminLayout currentPage="dashboard">
                    <PageHeader
                        title="Günlük İstatistikler"
                        subtitle="Salı, 14 Kasım 2023, 11:30"
                    >
                        <div className="relative">
                            <input
                                type="text"
                                placeholder="Ara..."
                                className="px-4 py-2 pl-10 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                            />
                            <svg
                                className="w-5 h-5 text-white/30 absolute left-3 top-2.5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                />
                            </svg>
                        </div>
                        <button className="p-2 bg-white/5 border border-white/10 rounded-xl text-white hover:bg-white/10 transition-colors">
                            <svg
                                className="w-5 h-5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                                />
                            </svg>
                        </button>
                    </PageHeader>

                    {/* İstatistik Kartları */}
                    <div className="grid grid-cols-3 gap-6 mb-8">
                        <StatCard
                            title="Toplam Gelir"
                            value="€9,460.00"
                            trend="up"
                            trendValue="15%"
                            subtitle="Geçen haftaya göre: €8,240.00"
                        />

                        <StatCard
                            title="Giderler"
                            value="€5,660.00"
                            trend="up"
                            trendValue="25%"
                            subtitle="Geçen haftaya göre: €4,520.00"
                        />

                        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
                            <h3 className="text-white/60 mb-2">
                                Kiralama vs İptal
                            </h3>
                            <div className="flex items-center justify-center h-24">
                                <div className="relative w-32 h-32">
                                    <svg
                                        viewBox="0 0 36 36"
                                        className="w-full h-full"
                                    >
                                        <path
                                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                            fill="none"
                                            stroke="#4B5563"
                                            strokeWidth="2"
                                            strokeDasharray="100, 100"
                                        />
                                        <path
                                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                            fill="none"
                                            stroke="#3B82F6"
                                            strokeWidth="2"
                                            strokeDasharray="54, 100"
                                        />
                                        <path
                                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                            fill="none"
                                            stroke="#A855F7"
                                            strokeWidth="2"
                                            strokeDasharray="26, 100"
                                            strokeDashoffset="-54"
                                        />
                                        <path
                                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                            fill="none"
                                            stroke="#EC4899"
                                            strokeWidth="2"
                                            strokeDasharray="20, 100"
                                            strokeDashoffset="-80"
                                        />
                                    </svg>
                                </div>
                            </div>
                            <div className="flex justify-between text-sm mt-2">
                                <div className="flex items-center">
                                    <div className="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
                                    <span>Kiralandı 54%</span>
                                </div>
                                <div className="flex items-center">
                                    <div className="w-3 h-3 bg-purple-500 rounded-full mr-2"></div>
                                    <span>Beklemede 26%</span>
                                </div>
                                <div className="flex items-center">
                                    <div className="w-3 h-3 bg-pink-500 rounded-full mr-2"></div>
                                    <span>İptal 20%</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Yat Durumu Tablosu */}
                    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 mb-8">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-xl font-bold">
                                Aktif Yat Durumu
                            </h2>
                            <button className="px-4 py-2 bg-white/5 border border-white/10 rounded-xl text-white hover:bg-white/10 transition-colors flex items-center gap-2">
                                <svg
                                    className="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                                    />
                                </svg>
                                Filtrele
                            </button>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead>
                                    <tr className="text-white/60 border-b border-white/10">
                                        <th className="text-left pb-3 font-medium">
                                            No.
                                        </th>
                                        <th className="text-left pb-3 font-medium">
                                            Yat no.
                                        </th>
                                        <th className="text-left pb-3 font-medium">
                                            Kaptan
                                        </th>
                                        <th className="text-left pb-3 font-medium">
                                            Durum
                                        </th>
                                        <th className="text-right pb-3 font-medium">
                                            Kazanç
                                        </th>
                                        <th className="text-center pb-3 font-medium">
                                            İşlem
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {yachtData.map((yacht, index) => (
                                        <tr
                                            key={yacht.id}
                                            className="border-b border-white/5 hover:bg-white/5"
                                        >
                                            <td className="py-4">
                                                {index + 1}
                                            </td>
                                            <td className="py-4">{yacht.id}</td>
                                            <td className="py-4">
                                                <div className="flex items-center">
                                                    <div className="w-8 h-8 bg-blue-500 rounded-full mr-3 flex items-center justify-center text-white font-bold">
                                                        {yacht.captain.charAt(
                                                            0
                                                        )}
                                                    </div>
                                                    {yacht.captain}
                                                </div>
                                            </td>
                                            <td className="py-4">
                                                <span
                                                    className={`px-2 py-1 rounded-full text-xs ${
                                                        yacht.status ===
                                                        "Tamamlandı"
                                                            ? "bg-green-500/20 text-green-400"
                                                            : yacht.status ===
                                                              "Beklemede"
                                                            ? "bg-blue-500/20 text-blue-400"
                                                            : "bg-red-500/20 text-red-400"
                                                    }`}
                                                >
                                                    {yacht.status}
                                                </span>
                                            </td>
                                            <td className="py-4 text-right">
                                                {yacht.earnings}
                                            </td>
                                            <td className="py-4 text-center">
                                                <button className="px-3 py-1 bg-blue-500 text-white rounded-lg text-sm hover:bg-blue-600 transition-colors">
                                                    Detaylar
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Revenue Chart */}
                    <RevenueChart />
        </AdminLayout>
    );
}

export default AdminPanel;